module.exports = __webpack_public_path__ + "static/img/SOUS-MAINS-PURE-ZONE-40X60cm.b15130b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/produits/SOUS-MAINS-PURE-ZONE-40X60cm.jpg
// module id = /J2K
// module chunks = 0